<template slot-scope="scope">
  <!-- 提成信息 表格组件 -->
  <div class="device-list">
    <div class="device-list-tab">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#409eff ',
          textAlign: 'center',
          color: '#ffffff',
          padding: '3px',
          fontSize: '12px',
          fontWeight: '400',
          height: '45px',
        }"
        :row-style="{ height: '35px' }"
      >
        <el-table-column label="订单ID" align="center" >
          <template slot-scope="scope">
            <span>{{ scope.row.orderNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column label="消费金额" align="center" >
          <template slot-scope="scope">
            <span>{{ scope.row.money }}</span>
          </template>
        </el-table-column>
        <el-table-column label="消费类型" align="center" >
          <template slot-scope="scope">
            <span>{{ scope.row.typeName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付方式" align="center" >
          <template slot-scope="scope">
            <span>{{ scope.row.payMethodName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="提成" align="center" >
          <template slot-scope="scope">
            <span>{{ scope.row.kickback }}侦迹币</span>
          </template>
        </el-table-column>
        <el-table-column label="时间" align="center" >
          <template slot-scope="scope">
            <span class="firm-clickable" @click="handelClickName(scope.row)">{{
              scope.row.createTime
            }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {}, //父组件传的表格数据
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {
    
  },
  methods: {
    //表格颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "warning-row";
      } else if (rowIndex % 2 == 1) {
        return "success-row";
      }
      return "success-row";
    },
  },
};
</script>

<style scoped lang="less">


/deep/th:nth-child(1) {
  border-radius: 10px 0 0 0 !important;
}
/deep/th:nth-child(6) {
  border-radius: 0px 10px 0px 0px !important;
}
// /deep/th:nth-last-child(2) {
//   border-radius: 0 10px 0 0 !important;
// }

/deep/th {
  height: 45px !important;
  padding: 0;
}
/deep/ td {
  height: 40px !important;
  padding: 0;
}
.device-list-tab {
  border: 1px solid #eeeeee;
  border-radius: 10px 10px 0 0;
}
/deep/.el-table__empty-block,
/deep/.el-table tr,
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  color: #333333;
  font-weight: 400;
  font-size: 12px;
}
/deep/.el-table .warning-row td {
  font-size: 12px;
  color: #333333;
}

::v-deep .el-table .warning-row td {
  background: #eeeeee !important;
}
/deep/.device-list {
  border: 1px solid goldenrod !important;
}
</style>
